import getSymbolFromCurrency from "currency-symbol-map";
// export const currency = {
//   INR: "Rs",
//   // INR: "₹",
//   USD: "$",
// };

export const currency = (cur) => {
  return getSymbolFromCurrency(cur);
};

export const promotionNames = {
  late: "Last Minute Deals",
  early: "Early Bird Offer",
  bulk: "Bulk Discount",
};
